var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning 1",
    clipPath: "url(#clip0_1099_22025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_bdi_1099_22025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5294 96.8261H14.4688C9.45472 96.8261 4.79716 94.2299 2.16127 89.9639C-0.475394 85.6987 -0.715162 80.3724 1.5276 75.8869L38.0579 13.3442C40.5093 8.44293 45.5187 5.34619 50.9991 5.34619C56.4795 5.34619 61.4889 8.44293 63.9403 13.3442L100.471 75.8869C102.713 80.3724 102.474 85.6987 99.837 89.9639C97.2011 94.2299 92.5443 96.8261 87.5294 96.8261Z",
    fill: "url(#paint0_linear_1099_22025)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.0358 80.9926C58.0358 84.8795 54.8846 88.0299 50.9985 88.0299C47.1124 88.0299 43.9619 84.8795 43.9619 80.9926C43.9619 77.1065 47.1124 73.9561 50.9985 73.9561C54.8846 73.9561 58.0358 77.1065 58.0358 80.9926Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.0364 80.9926C58.0364 82.8594 57.2953 84.6491 55.9758 85.9693C54.6555 87.2888 52.8658 88.0299 50.999 88.0299V73.9561C52.8658 73.9553 54.6555 74.6964 55.9758 76.0167C57.2953 77.3362 58.0364 79.1266 58.0364 80.9926Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.9985 19.4199C54.8846 19.4199 58.0358 22.5704 58.0358 26.4573V59.8823C58.0358 63.7684 54.8846 66.9188 50.9985 66.9188C47.1124 66.9188 43.9619 63.7684 43.9619 59.8823V26.4573C43.9619 22.5704 47.1124 19.4199 50.9985 19.4199Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.0364 26.4573V59.8823C58.0364 61.749 57.2953 63.5387 55.9758 64.8582C54.6555 66.1785 52.8658 66.9196 50.999 66.9188V19.4199C52.8658 19.4176 54.6578 20.1579 55.9781 21.4782C57.2976 22.7985 58.0387 24.5897 58.0364 26.4573Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_1099_22025",
    x: -40,
    y: -57.6538,
    width: 181.998,
    height: 174.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1099_22025"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1099_22025",
    result: "effect2_dropShadow_1099_22025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1099_22025",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1099_22025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1099_22025",
    x1: -1.93667,
    y1: 5.34619,
    x2: 121.712,
    y2: 73.4385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7E36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1099_22025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.84d8771c22b9eca29da47e99e2a80800.svg";
export { ForwardRef as ReactComponent };